module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026-2027.1789608252531.jpg";